import { render, staticRenderFns } from "./blog-byline.vue?vue&type=template&id=db5a9a82"
import script from "./blog-byline.vue?vue&type=script&lang=js"
export * from "./blog-byline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports